import React, { ReactNode } from 'react';
import { Collection } from 'react-aria-components';

interface Props {
  items: Array<any>;
  children: (item: any) => ReactNode;
}

export const MenuCollection = ({ items, children }: Props) => {
  return <Collection items={items}>{(item) => children(item)}</Collection>;
};

export default MenuCollection;
